export default {
  title: 'فرم دانش آموزان',
  detail: 'ایجاد و ویرایش  اطلاعات دانش آموزان',
  mobile : 'شماره موبایل',
  birthDate:'تاریخ تولد',
  schoolName:'اسم مدرسه',
  gender:'جنسیت',
  address:'ثبت آدرس',
  male:'مذکر',
  female:'مونث',
  email:'ایمیل',
  email_verified_at:'تاریخ تایید ایمیل',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  lastName : 'نام خانوادگی',
  firstName : 'نام',
  back : 'لغو',
  success : 'موفق',
  error : 'خطا',
  save : 'ذخیره',
  loading : 'در حال بارگزاری',
  saving : 'در حال بارگزاری ...',
  country:'کشور',
  selectCountry:'کشور را انتخاب نماید',
  province:'استان',
  selectProvince:'استان را انتخاب نماید',
  city:'شهر',
  selectCity:'شهر را انتخاب نماید',
  placeholderMobile:'شماره موبایل را وارد نماید',
  placeholderFirstName:'نام را وارد نماید',
  placeholderLastName:'نام خانوادگی را وارد نماید',
  placeholderSchoolName:'اسم مدرسه را وارد نماید',
  placeholderEmail:'آدرس ایمیل را وارد نماید',


}
